module.exports = __webpack_public_path__ + "static/media/15. Vibrando el ahora, Mixta en tela, 150 x 300 cm, 2017 copy.c86f76cd.png";